/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo} from "react";
import {createUseStyles} from "react-jss";
import UI from "../UI";

const useStyles = createUseStyles({
    root: {
        margin: "4rem 0",
        backgroundColor: UI.colors.lightGrey.toCSS(),
        height: 2,
        border: 0
    }
});

function Divider() {
    const classes = useStyles();
    return <hr className={classes.root} />;
}

export default memo(Divider);
